const en = {
  common: {
    pageTitle: "Công ty Cổ phần Quantera",
  },
  
  header: {
    nav: {
      about: "Giới thiệu",
      solutions: "Giải pháp",
      apps: "Ứng dụng",
      ecosystem: "Hệ sinh thái",
      partners: "Hợp tác",
      blogs: "Blog",
      contact: "Liên hệ",
      trynow: "Đăng ký trải nghiệm ngay",
    },
    hero: {
      brand: "QUANTERA",
      headline: "NỀN TẢNG DANH TÍNH SỐ & KÝ SỐ\nTỰ CHỦ TIÊN PHONG",
      headline1: "NỀN TẢNG ĐỊNH DANH SỐ & KÝ SỐ",
      headline2: "TỰ CHỦ TIÊN PHONG",
      sub: "Giải pháp toàn diện cho chính phủ điện tử, eKYC, eID, Tài chính số, Giáo dục và Dịch vụ số.",
      trynow: "Đăng ký trải nghiệm ngay",
      explore: "Khám phá giải pháp",
    },
  },

  footer: {
    explore: {
      title:
        "Khám phá Quantera — nền tảng Blockchain cấp doanh nghiệp đạt chuẩn quốc tế, tích hợp toàn diện định danh số tự chủ, chứng thư số điện tử, chữ ký số tin cậy cao và ví định danh số được tích hợp trong một giải pháp toàn diện.",
    },
    contact: {
      contact: "Liên hệ",
      address:
        "Tầng 9, Tòa nhà Văn Phòng Thủy Lợi 4, Số 286-288 Nguyễn Xí, Phường Bình Lợi Trung, TP. Hồ Chí Minh",
    },
    about: {
      aboutquantera: "Về Quantera",
      about: "Giới thiệu",
      solutions: "Giải pháp",
      applications: "Ứng dụng",
      partners: "Hợp tác",
      blogs: "Blog",
      contact: "Liên hệ",
      ecosystem: "Hệ sinh thái",
    },
    certificate: {
      certificate: "Chứng nhận",
    },
    links: {
      privacy: "Chính sách bảo mật",
      terms: "Điều khoản sử dụng",
    },
  },

  about: {
    caption: "GIỚI THIỆU",
    headline1: "Một nền tảng – Mọi kết nối tin cậy giữa",
    headline2: "Chính phủ và Doanh nghiệp",
    sub: "Quantera là nền tảng kết nối chính phủ và doanh nghiệp thông qua công nghệ Blockchain tiên tiến, bảo mật, tự chủ và đạt chuẩn quốc tế. Nhằm đảm bảo Xác thực danh tính số An toàn, Minh bạch, Chống gian lận trên không gian mạng và bảo vệ quyền riêng tư của người sử dụng",

    cards: {
      mission: {
        mission: "Sứ mệnh",
        text: "Xây dựng nền tảng Blockchain tin cậy, giúp các tổ chức, doanh nghiệp và chính phủ:",
        li1: "Quản lý tự chủ định danh số (SSI).",
        li2: "Triển khai chữ ký số đủ điều kiện có giá trị pháp lý cao (QES). ",
        li3: "Cấp phát & xác minh chứng thư số (VC).",
        li4: "Phát triển ví định danh số an toàn.",
      },

      vision: {
        title: "Tầm nhìn",
        text: "Trở thành nền tảng hạ tầng số cốt lõi hàng đầu tại Việt Nam và Đông Nam Á trong lĩnh vực định danh và chữ ký số, hoàn toàn phù hợp với các tiêu chuẩn quốc tế. ",
      },

      values: {
        title: "Giá trị cốt lõi",
        li1: "Tự chủ công nghệ.",
        li2: "An toàn dữ liệu.",
        li3: "Bảo mật tối đa.",
        li4: "Khả năng mở rộng cao.",
        li5: "Tương thích tiêu chuẩn quốc tế (EBSI, eIDAS, EUDI Wallet).",
      },
    },
  },

  solutions: {
    caption: "GIẢI PHÁP",
    headline: "Hệ thống định danh số toàn diện cho kỷ nguyên số",
    sub: "Bộ giải pháp định danh số tích hợp SSI, VC, QES và ví eID giúp người dùng tự chủ dữ liệu, ký số an toàn, lưu trữ và xác minh danh tính theo các chuẩn quốc tế, sẵn sàng cho dịch vụ số và chính phủ điện tử.",

    cards: {
      ssi: {
        title: "Self-Sovereign Identity (SSI)",
        items: [
          "Giải pháp quản lý định danh số cho phép người dùng tự kiểm soát dữ liệu cá nhân.",
          "Tích hợp Decentralized Identifiers (DID) và ZKP.",
          "Cấp phát, lưu trữ, xác minh định danh số an toàn.",
        ],
      },
      vc: {
        title: "Verifiable Credentials (VC)",
        items: [
          "Giải pháp cấp phát và xác minh chứng thư số.",
          "Hỗ trợ các loại chứng thư như eID, eKYC, giấy phép, văn bằng số.",
          "Đáp ứng chuẩn EBSI, W3C VC.",
        ],
      },
      qes: {
        title: "Qualified Electronic Signature (QES)",
        items: [
          "Chữ ký số đạt giá trị pháp lý cao nhất.",
          "Hỗ trợ nhiều nhà cung cấp chữ ký số (CA) Việt Nam và quốc tế.",
          "Tuân thủ theo eIDAS (Châu Âu) và tiêu chuẩn ký số Việt Nam.",
        ],
      },
      wallet: {
        title: "Ví điện tử & Ví eID",
        items: [
          "Ví điện tử đa năng lưu trữ khóa cá nhân, DID, VC.",
          "Hỗ trợ chuẩn EUDI Wallet.",
          "Bảo mật, tiện lợi, sẵn sàng tích hợp dịch vụ chính phủ điện tử.",
        ],
      },
    },
  },

  app: {
    caption: "GIẢI PHÁP",
    headline: "Công nghệ cốt lõi của Quantera",
    sub: "Nền tảng định danh số ứng dụng công nghệ Blockchain Hyperledger Fabric, tích hợp các thành phần như SSI, chữ ký số (QES), ví điện tử bảo mật và khả năng kết nối xuyên biên giới. Hệ thống tuân thủ các tiêu chuẩn quốc tế (EBSI, EUDI Wallet, DIDComm), đảm bảo tự chủ định danh, bảo vệ dữ liệu cá nhân và tương thích với hạ tầng định danh số toàn cầu. ",

    features: {
      blockchain: {
        title: "Blockchain Core: Hyperledger Fabric",
        desc: [
          "Mạng Blockchain có cấp phép tiên tiến, chuyên biệt cho doanh nghiệp và chính phủ.",
          "Khả năng phân quyền, mở rộng cao, an toàn, bảo mật.",
        ],
        titlesub: "TIN CẬY",
        titlesub1: "& BẢO MẬT",
      },
      ssi: {
        title: "Self-Sovereign Identity (SSI)",
        desc: [
          "Xây dựng trên công nghệ DID, VC, ZKP, JWT, JSON-LD. ",
          "Tự chủ định danh, bảo vệ dữ liệu cá nhân.",
        ],
        titlesub: "TỰ CHỦ",
        titlesub1: "DANH TÍNH",
      },
      qes: {
        title: "Qualified Electronic Signature (QES) ",
        desc: [
          "Tích hợp với các Tổ chức chứng thực chữ ký số tại Việt Nam và Quốc Tế. ",
          "Hỗ trợ nhiều phương thức ký: ký từ xa, ký tại chỗ.",
        ],
        titlesub: "GIÁ TRỊ",
        titlesub1: "PHÁP LÝ",
      },
      wallet: {
        title: "Ví Điện Tử",
        desc: [
          "Quản lý DID, VC và QES trong một ứng dụng duy nhất.",
          "Tuân thủ chuẩn EUDI Wallet, đảm bảo quyền riêng tư dữ liệu tuyệt đối.",
        ],
        titlesub: "VÍ",
        titlesub1: "BẢO MẬT",
      },
      intero: {
        title: "Khả Năng Kết Nối",
        desc: [
          "Tương thích với EBSI, EUDI Wallet, DIDComm.",
          "Sẵn sàng kết nối xuyên biên giới với hệ sinh thái eID Quốc Tế.",
        ],
        titlesub: "KẾT NỐI",
        titlesub1: "TOÀN CẦU",
      },
    },
  },

  partners: {
    caption: "HỢP TÁC",
    headline: "Đối tác đồng hành",
    items: {
      goverment: {
        title: "Chính phủ, cơ quan nhà nước",
        description:
          "Điều phối, quản lý dữ liệu dân cư, văn bằng, dịch vụ công.",
      },
      bank: {
        title: "Ngân hàng, tổ chức tài chính",
        description:
          "Tiên phong ứng dụng Blockchain trong chuyển tiền, L/C, và chương trình khách hàng thân thiết.",
      },
      enterprise: {
        title: "Doanh nghiệp dịch vụ số",
        description:
          "Trực tiếp kết nối với người dùng, tích hợp Blockchain vào thanh toán, hóa đơn, eKYC, và chương trình khách hàng thân thiết.",
      },
      blockchain: {
        title: "Nhà cung cấp Blockchain, Chữ ký số",
        description:
          "Tiềm năng kết hợp Blockchain để nâng cấp sang định danh và chữ ký số phi tập trung.",
      },
    },
  },

  applications: {
    caption: "ỨNG DỤNG",
    headline: "Quantera - Hạ tầng định danh số liên thông & bảo mật",
    sub: "Ứng dụng hỗ trợ định danh số, eKYC, ký số và lưu trữ hồ sơ điện tử, phục vụ đa lĩnh vực như chính phủ điện tử, ngân hàng, tài chính, viễn thông, giúp xác minh an toàn, giảm gian lận và mở rộng dịch vụ số.",

    slides: {
      egov: {
        title: "Chính phủ điện tử (e-Government)",
        bullets: [
          "eID, giấy tờ số công dân, hồ sơ điện tử.",
          "Chữ ký số điện tử trên các nền tảng dịch vụ công.",
        ],
      },
      ekyc: {
        title: "eKYC & Định danh số",
        bullets: [
          "Xác minh danh tính số cho tài chính, ngân hàng, viễn thông.",
          "Giảm thiểu gian lận, rủi ro.",
        ],
      },
      docsign: {
        title: "Ký số giao dịch pháp lý",
        bullets: [
          "Hợp đồng điện tử, hồ sơ pháp lý ký số an toàn, hợp lệ.",
        ],
      },
      bank: {
        title: "Ngân hàng & Tài chính số",
        bullets: [
          "eKYC, ví điện tử, dịch vụ thanh toán dựa trên định danh số. ",
          "Mở rộng dịch vụ tài chính số an toàn.",
        ],
      },
    },
  },

  ecosystem: {
    caption: "HỆ SINH THÁI",
    headline: "Hệ sinh thái Quantera",
    gopaperlessagent:"An toàn, linh hoạt và tối ưu vận hành với SAP 2FA và quản lý khóa tập trung.",
    gopaperless:"Làm việc thông minh, an toàn và dễ dàng ký các tài liệu ràng buộc về pháp lý tại Việt Nam.",
    trustedbilling:"Tự động hóa thanh toán, lập hóa đơn điện tử và đối chiếu thời gian thực"
  },

  contact: {
    caption: "LIÊN HỆ",
    title: {
      line1: "Bạn cần tư vấn hay",
      line2: "demo giải pháp?",
    },
    subtitle: {
      prefix: "Hãy liên hệ ngay với",
      brand: "QUANTERA",
    },
    form: {
      title: "Liên hệ với chúng tôi",
      name: "Họ và tên",
      phone: "Số điện thoại",
      email: "Email",
      company: "Công ty",
      message: "Nội dung",
      submit: "Gửi ngay",
      sending: "Đang gửi...",
      required: "Trường bắt buộc",
      invalidEmail: "Email không hợp lệ",
      invalidPhone: "Số điện thoại không hợp lệ",
      success: "Gửi thành công!",
      error: "Có lỗi xảy ra, vui lòng thử lại.",
    },
  },

  chat: {
    title: "Trợ lý Quantera",
    subtitle: "Hỏi về giải pháp & hệ sinh thái",
    welcome: "Xin chào! Mình có thể giúp bạn tìm hiểu về Quantera, GoPaperless Agent/Portal và Trusted Billing.",
    placeholder: "Nhập câu hỏi...",
    send: "Gửi",
    open: "Mở chat",
    close: "Đóng chat",
    thinking: "Đang trả lời...",
    contact: "Liên hệ",
    call: "Gọi 1900 6884",
    zalo: "Chat Zalo",
    learnMore: "Tìm hiểu thêm",
    error: "Không thể kết nối chatbot. Vui lòng liên hệ form Liên hệ hoặc gọi 1900 6884.",
    quickReplies: {
      q1: "Quantera là gì?",
      q2: "Agent khác Portal?",
      q3: "Trusted Billing là gì?",
    },
  },

  cookies: {
    title: "Trang web này sử dụng cookie",
    description: 'Bằng cách xác nhận "Chấp nhận Tất cả", bạn đồng ý cho phép lưu trữ cookie trên thiết bị của mình nhằm cải thiện khả năng điều hướng trang web, phân tích việc sử dụng trang và hỗ trợ các hoạt động tiếp thị của chúng tôi.',
    preferences: "Tùy chọn cookie",
    rejectAll: "Từ chối Tất cả",
    acceptAll: "Chấp nhận Tất cả",

    preferencesTitle: "Thiết lập cookie tùy chọn",
    strictlyNecessary: "Cookie bắt buộc",
    strictlyNecessaryDesc: "Những cookie này cần thiết để trang web hoạt động đúng cách. Chúng không thu thập dữ liệu cho mục đích quảng cáo và không thể tắt đi, vì điều đó sẽ làm gián đoạn các chức năng cơ bản của trang web.",
    alwaysActive: "Luôn hoạt động",

    functional: "Cookie chức năng / Tùy chọn",
    functionalDesc: "Những cookie này ghi nhớ các lựa chọn và cài đặt của bạn để mang lại trải nghiệm cá nhân hóa hơn, chẳng hạn như ngôn ngữ đã chọn, chế độ sáng/tối, cỡ chữ, khu vực hoặc các tùy chỉnh khác.",

    analytics: "Cookie phân tích / Hiệu suất",
    analyticsDesc: "Những cookie này giúp chúng tôi hiểu cách người dùng tương tác với trang web. Toàn bộ dữ liệu đều được ẩn danh hoàn toàn và chỉ dùng để cải thiện hiệu suất trang web, tốc độ tải trang và chất lượng nội dung – không nhận dạng cá nhân.",

    marketing: "Cookie quảng cáo / Tiếp thị",
    marketingDesc: "Những cookie này cho phép chúng tôi hiển thị quảng cáo phù hợp hơn với sở thích của bạn trên trang web của chúng tôi và các nền tảng khác. Chúng theo dõi hành vi duyệt web một cách ẩn danh và ngăn chặn việc hiển thị cùng một quảng cáo lặp lại nhiều lần.",

    savePreferences: "Lưu thiết lập",
    cancel: "Hủy"
  }
};

export default en;
